/* eslint-disable no-param-reassign */
const NUMBER_REGEX = /^\d+$/;
const SKIP_NODE_NAMES = ['', null, undefined];
const nodeNamesToPath = (nodeNames) => nodeNames.reduce((pathAcc, nodeName) => {
    if (!SKIP_NODE_NAMES.includes(nodeName)) {
        if (nodeName === '*' || NUMBER_REGEX.test(`${nodeName}`)) {
            pathAcc += '[*]';
        }
        else {
            if (pathAcc) {
                pathAcc += '.';
            }
            pathAcc += nodeName;
        }
    }
    return pathAcc;
}, '');
const INVALID_FILTER_CONFIG_VALUES = ['', null, undefined, true, false];
const VALID_REPLACE_CONFIG_TYPES = ['string', 'number', 'boolean', 'function'];
const isReplacer = (replacer) => replacer === null || VALID_REPLACE_CONFIG_TYPES.includes(typeof replacer);
const prepareConfig = ({ replace: replaceConfig = {}, filter: filterConfig = [], }) => {
    const filteredReplaceConfig = Object.keys(replaceConfig).reduce((res, replaceConfigKey) => {
        const replacer = replaceConfig[replaceConfigKey];
        if (isReplacer(replacer)) {
            res[replaceConfigKey] = replacer;
        }
        return res;
    }, {});
    const filteredFilterConfigObject = filterConfig.reduce((res, path) => {
        if (INVALID_FILTER_CONFIG_VALUES.includes(path)) {
            return res;
        }
        return Object.assign(Object.assign({}, res), { [path]: true });
    }, {});
    const paths = [
        ...Object.keys(filteredFilterConfigObject),
        ...Object.keys(filteredReplaceConfig),
    ];
    if (paths.length) {
        return {
            replaceConfig: filteredReplaceConfig,
            filterConfig: filteredFilterConfigObject,
        };
    }
    throw new TypeError('required replace or filter in transformConfig');
};
const getReplaceValue = (value, replacer) => {
    if (isReplacer(replacer)) {
        return typeof replacer === 'function' ? replacer(value) : replacer;
    }
    return value;
};

export { getReplaceValue, isReplacer, nodeNamesToPath, prepareConfig };
